export default __webpack_public_path__ + "static/Logo-c87fd11f703b0f6ac702a6298ce44616.svg";